import React, { useState, useEffect } from 'react';

import Header from './components/Header';
import Login from './components/Login';
import AddEditCard from './views/AddEditCard';
import { LOGIN, PRACTICE_CARDS, ADD_EDIT_CARD } from './views/catalog';
import PracticeCards from './views/PracticeCards';

export default function App() {
  const [currentView, setViewPage] = useState(LOGIN);
  const [userSecret, setUserSecret] = useState(null);
  useEffect(() => {
    if (userSecret === null) {
      setViewPage(LOGIN);
    }
  });
  const chooseView = (view, secret) => {
    if (secret === null) {
      return <Login setUserSecret={setUserSecret} setViewPage={setViewPage} />;
    }
    switch(view) {
      case ADD_EDIT_CARD:
        return <AddEditCard userSecret={userSecret} />;
      case PRACTICE_CARDS:
        return <PracticeCards userSecret={userSecret} />;
    }
  };
  return (
    <div>
      <Header userSecret={userSecret} setUserSecret={setUserSecret} currentView={currentView} setViewPage={setViewPage} />
      {chooseView(currentView, userSecret)}
    </div>
  );
}
